/** GET /api/lens/lens_show 等接口中的 merge_brand，线上偶有字符串形态 */

export const MERGE_BRAND_WITH_BRANDS = 1;
export const MERGE_BRAND_COLOR_LIST = 2;

export function getMergeBrand(mergeBrand?: unknown): number {
  if (mergeBrand == null) return 0;
  const n = Number(mergeBrand);
  return Number.isFinite(n) ? n : 0;
}

export function isMergeBrandDropdownLens(item: { merge_brand?: unknown } | null | undefined) {
  return getMergeBrand(item?.merge_brand) === MERGE_BRAND_WITH_BRANDS;
}

export function isMergeBrandFlatColorLens(item: { merge_brand?: unknown } | null | undefined) {
  return getMergeBrand(item?.merge_brand) === MERGE_BRAND_COLOR_LIST;
}
